const incidentInvolvements = (() => {
  let involvementTable, involvementData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Involvements
  //-------------------------------------------------------------------------------

  function getIncidentInvolvementView() {
    const frag = document.createDocumentFragment();
    
    involvementTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Type'],
      endIcon: true,
    });

    const headers = involvementTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addInvolvementBtnDiv = document.createElement('div');
    const addInvolvementBtn = new Button({
      text: 'ADD NEW INVOLVEMENT',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(involvementTable);
    if ($.session.SetupInsert) {
      addInvolvementBtn.button.style.float = 'right';
      addInvolvementBtn.renderTo(addInvolvementBtnDiv);
      frag.append(addInvolvementBtnDiv);
    }

    const tableInvolvementData = involvementData
      .map(p => {
        return {
          values: [p.involvementName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showInvolvementPopup(p);
          },
          endIconCallback: () => handleInvolvementDelete(p),
        };
      });

    table.populate(involvementTable, tableInvolvementData);
    table.sortTableByHeader(involvementTable);

    addInvolvementBtn.onClick(e => {
      showInvolvementPopup();
    });

    return frag;
  }

  // Incident Involvements
  //-------------------------------------------------------------------------------

  function showInvolvementPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const involvementForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Type',
          id: 'cName',
          required: true,
        },
        {
          type: 'select',
          label: 'Hide From Employee?',
          id: 'cHideEmployee',
          data: [
            { value: 'Y', text: 'Yes' },
            { value: 'N', text: 'No' },
          ],
        },
      ],
    });

    involvementForm.onKeyup(() => {
      involvementForm.inputs['cName'].setValidtyError('');
      involvementForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(involvementForm);
    });
    involvementForm.onChange(event => {
      involvementForm.inputs['cName'].setValidtyError('');
      involvementForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(involvementForm);
    });

    involvementForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentInvolvementData', {
          id: rowData ? rowData.involvementId : 0,
          involvementName: formdata.cName.trim(),
          isHideEmployee: formdata.cHideEmployee,
          userId: $.session.UserId
        })
      ).insertUpdateIncidentInvolvementDataResult;
      const newID = resp.involvementId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This involvement already exists.', involvementForm);
        involvementForm.buttons['submit'].toggleDisabled(true);
        involvementForm.buttons['cancel'].toggleDisabled(true);
      } else {
        involvementForm.clear();
        POPUP.hide(popup);
        await getInvolvementData();
        updateInvolvementTable();
      }
    });

    involvementForm.onCancel(event => {
      involvementForm.clear();
      involvementForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    involvementForm.renderTo(popup);

    POPUP.show(popup);

    involvementForm.populate({
      cName: rowData ? rowData.involvementName : '',
      cHideEmployee: rowData ? rowData.isHideEmployee : 'N',
    });

    involvementForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      involvementForm.disableFormInputs();
    }
  }

  async function handleInvolvementDelete(row) {
    const rowData = involvementData.find(a => a.involvementId == row.involvementId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This involvement type is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this involvement type?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentInvolvementData', {
            token: $.session.Token,
            involvementId: row.involvementId,
          });

          await getInvolvementData();
          updateInvolvementTable();
        }
      });
    }
  }
  function updateInvolvementTable() {
    const tableInvolvementData = involvementData
      .map(p => {
        return {
          values: [p.involvementName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showInvolvementPopup(p);
          },
          endIconCallback: () => handleInvolvementDelete(p),
        };
      });

    table.populate(involvementTable, tableInvolvementData);
  }

  async function getInvolvementData() {
    const dataInvolvement = await _UTIL.fetchData('getIncidentInvolvement');
    involvementData = dataInvolvement.getIncidentInvolvementResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getInvolvementData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Involvements';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Involvements') {
      viewMarkup = getIncidentInvolvementView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
